import React from "react";

export const StartupIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 0 36 36">
			<path
				d="M35.923,0.063C35.301,0.02,34.695,0,34.102,0C21.2,0,13.854,9.835,11.183,17.75l7.09,7.087
            C26.416,21.923,36,14.85,36,2.088C36,1.427,35.976,0.754,35.923,0.063z M19.006,21.329l-4.323-4.322
            c1.832-4.29,7.037-13.419,18.297-13.981C32.604,11.688,26.919,17.923,19.006,21.329z M27.213,23.637
            c-0.821,0.561-1.635,1.067-2.441,1.517c-0.281,1.334-0.994,2.762-2.025,3.977c-0.003-0.863-0.244-1.733-0.665-2.609
            c-0.744,0.338-1.45,0.628-2.124,0.883c0.993,2.563-0.018,4.458-1.373,6.233c1.943-0.147,3.985-1.099,5.591-2.707
            C25.914,29.197,27.127,26.696,27.213,23.637z M9.484,13.933c-0.868-0.418-1.737-0.656-2.597-0.661
            c1.204-1.021,2.615-1.729,3.938-2.018c0.471-0.83,1-1.647,1.556-2.449c-3.058,0.083-5.562,1.301-7.296,3.035
            c-1.607,1.607-2.559,3.647-2.706,5.592c1.775-1.357,3.67-2.364,6.234-1.373C8.875,15.353,9.162,14.645,9.484,13.933z M21.09,14.927
            c-0.586-0.585-0.586-1.535,0-2.12c0.585-0.587,1.536-0.587,2.12,0c0.587,0.586,0.587,1.536,0,2.122
            C22.623,15.515,21.676,15.515,21.09,14.927z M28.514,7.502c-1.169-1.17-3.071-1.17-4.242,0c-1.17,1.171-1.17,3.073,0,4.242
            c1.171,1.172,3.073,1.172,4.244,0C29.686,10.575,29.686,8.674,28.514,7.502z M25.65,10.368c-0.412-0.41-0.412-1.076,0-1.484
            c0.407-0.411,1.075-0.411,1.486,0c0.408,0.409,0.408,1.075,0,1.484C26.726,10.776,26.062,10.776,25.65,10.368z M2.954,29.366
            l-1.359-1.357l7.813-7.783l1.359,1.36L2.954,29.366z M10.42,32.15l-1.359-1.357l5.454-5.498l1.36,1.36L10.42,32.15z M1.359,36
            L0,34.642l9.671-9.656l1.361,1.359L1.359,36z"
			/>
		</svg>
	);
};

export const IrIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="37px" height="22px" viewBox="0 0 37 22">
			<path
				d="M37,2.008L19.795,22L9.25,12.571l2.033-2.342l8.234,7.363L34.727,0L37,2.008L37,2.008z M2.033,10.229
            l10.537,9.444L10.545,22L0,12.571L2.033,10.229z M16.337,10.573L25.465,0l2.285,2.02l-9.128,10.616L16.337,10.573z"
			/>
		</svg>
	);
};

export const TaxIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21px" height="18px" viewBox="0 0 21 18">
			<path
				d="M0,0h6.429c3.807,0,6.848,0.993,6.848,4.452c0,1.597-0.914,3.339-2.397,3.896v0.096
            c1.854,0.484,3.263,1.839,3.263,4.233c0,3.678-3.189,5.323-7.195,5.323H0V0z M6.256,7.137c1.878,0,2.72-0.797,2.72-2.032
            c0-1.283-0.866-1.814-2.72-1.814h-1.83v3.846H6.256z M6.626,14.686c2.125,0,3.214-0.75,3.214-2.299c0-1.475-1.063-2.055-3.214-2.055
            H4.426v4.354H6.626z M16.575,0H21v18h-4.425V0z"
			/>
		</svg>
	);
};

export const SupplyIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
			<path
				d="M24,14.188V9.813c-2.148-0.766-2.727-0.802-3.027-1.529c-0.303-0.729,0.084-1.169,1.06-3.223l-3.093-3.093
            c-2.026,0.963-2.488,1.364-3.224,1.059C14.988,2.725,14.947,2.138,14.188,0H9.813c-0.764,2.144-0.8,2.725-1.529,3.027
            C7.533,3.339,7.081,2.926,5.061,1.968L1.968,5.061C2.945,7.116,3.33,7.554,3.027,8.285C2.725,9.012,2.146,9.049,0,9.813v4.375
            c2.139,0.761,2.725,0.8,3.027,1.528c0.304,0.734-0.081,1.167-1.059,3.224l3.093,3.093c1.999-0.95,2.47-1.373,3.223-1.06
            C9.012,21.275,9.047,21.854,9.813,24h4.375c0.757-2.131,0.798-2.723,1.537-3.031c0.744-0.308,1.186,0.1,3.215,1.063l3.093-3.094
            c-0.976-2.048-1.362-2.492-1.06-3.222C21.273,14.989,21.854,14.953,24,14.188z M19.125,14.951c-0.578,1.395-0.069,2.458,0.488,3.578
            l-1.084,1.084c-1.093-0.543-2.161-1.076-3.573-0.49c-1.396,0.581-1.79,1.693-2.188,2.876h-1.534
            c-0.398-1.186-0.791-2.297-2.183-2.875c-1.419-0.588-2.507-0.045-3.579,0.488l-1.083-1.084c0.557-1.118,1.066-2.179,0.487-3.58
            C4.297,13.559,3.185,13.165,2,12.768v-1.534c1.185-0.398,2.297-0.791,2.875-2.185c0.579-1.393,0.068-2.458-0.487-3.578l1.084-1.084
            c1.082,0.538,2.162,1.077,3.58,0.487C10.443,4.298,10.836,3.185,11.234,2h1.534c0.398,1.185,0.792,2.297,2.185,2.875
            c1.418,0.588,2.505,0.045,3.579-0.487l1.083,1.084c-0.557,1.121-1.065,2.187-0.488,3.58c0.577,1.392,1.689,1.785,2.875,2.183v1.534
            C20.814,13.166,19.7,13.559,19.125,14.951z M12,9c1.654,0,3,1.347,3,3c0,1.654-1.346,3-3,3c-1.654,0-3-1.346-3-3
            C9,10.346,10.346,9,12,9z M12,7c-2.762,0-5,2.237-5,5c0,2.761,2.237,5,5,5c2.761,0,5-2.238,5-5C17,9.238,14.761,7,12,7z"
			/>
		</svg>
	);
};

export const HrIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="22px" height="24px" viewBox="0 0 22 24">
			<path
				d="M8.602,3.7c-1.154,1.937-0.635,5.227,1.424,9.024c0.93,1.713,0.697,3.021,0.338,3.815
            c-0.982,2.178-3.675,2.799-6.525,3.456C1.875,20.45,2,20.866,2,24H0.005L0,22.759c0-2.52,0.199-3.975,3.178-4.663
            c3.365-0.777,6.688-1.473,5.09-4.418C3.535,4.949,6.918,0,12,0c3.32,0,5.971,2.117,5.971,6.167c0,3.555-1.949,6.833-2.384,7.833
            h-2.114c0.391-1.536,2.498-4.366,2.498-7.842C15.971,1.005,10.104,1.173,8.602,3.7z M22,19h-3v-3h-2v3h-3v2h3v3h2v-3h3V19z"
			/>
		</svg>
	);
};

export const DocumentIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20px" height="24px" viewBox="0 0 20 24">
			<path
				d="M11,6c3.469,0,2,5,2,5s5-1.594,5,2v9H6V6H11z M11.827,4H4v20h16V12.158C20,9.766,14.988,4,11.827,4z M12,2
            L9,0H0v22h2V2H12z"
			/>
		</svg>
	);
};

export const VcIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
			<path d="M7,21H3V10h4V21z M14,10h-4v11h4V10z M21,10h-4v11h4V10z M23,22H1v2h22V22z M0,9h24L12,0L0,9z" />
		</svg>
	);
};

export const PlusIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="23px" height="23px" viewBox="0 0 23 23">
			<polygon points="12,11 12,0 11,0 11,11 0,11 0,12 11,12 11,23 12,23 12,12 23,12 23,11 " />
		</svg>
	);
};

export const PlayBtnIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21px" height="22px" viewBox="0 0 21 22">
			<path d="M10.506,21.060 C4.714,21.060 0.001,16.349 0.001,10.557 C0.001,4.767 4.714,0.055 10.506,0.055 C16.298,0.055 21.011,4.767 21.011,10.557 C21.011,16.349 16.298,21.060 10.506,21.060 ZM10.506,1.040 C5.256,1.040 0.986,5.310 0.986,10.557 C0.986,15.806 5.256,20.074 10.506,20.074 C15.755,20.074 20.026,15.806 20.026,10.557 C20.026,5.310 15.755,1.040 10.506,1.040 ZM8.916,6.826 L14.647,10.557 L8.916,14.289 L8.916,6.826 Z" />
		</svg>
	);
};

export const PaperIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="19px" height="19px" viewBox="0 0 19 19">
			<path d="M16.543,16.975 L15.549,16.975 C15.441,17.848 14.719,18.536 13.812,18.536 L2.631,18.536 C1.650,18.536 0.852,17.743 0.852,16.767 L0.852,2.367 C0.852,1.391 1.650,0.597 2.631,0.597 L13.812,0.597 C14.737,0.597 15.477,1.312 15.560,2.212 L16.543,2.212 C17.780,2.212 18.785,3.212 18.785,4.441 L18.785,14.745 C18.785,15.974 17.780,16.975 16.543,16.975 ZM14.054,2.367 C14.054,2.234 13.946,2.126 13.812,2.126 L2.631,2.126 C2.497,2.126 2.389,2.234 2.389,2.367 L2.389,16.767 C2.389,16.900 2.497,17.008 2.631,17.008 L13.812,17.008 C13.946,17.008 14.054,16.900 14.054,16.767 L14.054,2.367 ZM17.248,4.441 C17.248,4.055 16.932,3.741 16.543,3.741 L15.591,3.741 L15.591,15.446 L16.543,15.446 C16.932,15.446 17.248,15.132 17.248,14.745 L17.248,4.441 ZM11.024,13.919 L5.329,13.919 C4.905,13.919 4.561,13.577 4.561,13.155 C4.561,12.733 4.905,12.390 5.329,12.390 L11.024,12.390 C11.449,12.390 11.793,12.733 11.793,13.155 C11.793,13.577 11.449,13.919 11.024,13.919 ZM11.024,10.390 L5.329,10.390 C4.905,10.390 4.561,10.047 4.561,9.626 C4.561,9.204 4.905,8.861 5.329,8.861 L11.024,8.861 C11.449,8.861 11.793,9.204 11.793,9.626 C11.793,10.047 11.449,10.390 11.024,10.390 ZM11.024,6.743 L5.329,6.743 C4.905,6.743 4.561,6.401 4.561,5.978 C4.561,5.557 4.905,5.214 5.329,5.214 L11.024,5.214 C11.449,5.214 11.793,5.557 11.793,5.978 C11.793,6.401 11.449,6.743 11.024,6.743 Z" />
		</svg>
	);
};

export const MoreIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22">
			<path
				fill="#FFE400"
				d="M11.182 22.13C5.114 22.13.179 17.79.179 11.12c0-6.174 4.935-11 11.003-11 6.068 0 11.004 4.826 11.004 11 0 6.67-4.936 11.01-11.004 11.01zm0-20.147c-4.979 0-9.032 4.357-9.032 9.137 0 4.871 4.053 9.3 9.032 9.3 4.98 0 9.032-4.429 9.032-9.3 0-4.78-4.052-9.137-9.032-9.137zm0 15.198a1.288 1.288 0 1 1 0-2.577 1.288 1.288 0 0 1 0 2.577zm0-3.391c-.545 0-.986-1.151-.986-.85V5.226a.986.986 0 0 1 1.972 0v7.714c0-.301-.441.85-.986.85z"
			/>
		</svg>
	);
};

//---- sns 아이콘
export const FooterFacebookIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13px" height="24px">
			<path
				fill="rgb(82, 112, 177)"
				d="M3.839,7.1000 L0.839,7.1000 L0.839,11.1000 L3.839,11.1000 L3.839,23.1000 L8.838,23.1000 L8.838,11.1000 L12.480,11.1000 L12.838,7.1000 L8.838,7.1000 L8.838,6.333 C8.838,5.378 9.030,4.999 9.954,4.999 L12.838,4.999 L12.838,-0.000 L9.030,-0.000 C5.435,-0.000 3.839,1.583 3.839,4.615 L3.839,7.1000 Z"
			/>
		</svg>
	);
};

export const FooterYoutubeIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="25px" height="19px">
			<path
				fill="rgb(219, 37, 35)"
				d="M20.447,0.926 C16.844,0.682 8.818,0.682 5.219,0.926 C1.323,1.191 0.864,3.530 0.835,9.688 C0.864,15.835 1.319,18.184 5.219,18.450 C8.819,18.693 16.844,18.694 20.447,18.450 C24.344,18.185 24.803,15.846 24.832,9.688 C24.803,3.541 24.348,1.192 20.447,0.926 ZM9.834,13.663 L9.834,5.712 L17.833,9.681 L9.834,13.663 Z"
			/>
		</svg>
	);
};

export const FooterTwitterIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="25px" height="21px">
			<path
				fill="rgb(54, 145, 208)"
				d="M24.826,3.079 C23.943,3.480 22.994,3.750 21.999,3.872 C23.015,3.249 23.796,2.261 24.163,1.085 C23.212,1.662 22.159,2.081 21.037,2.307 C20.140,1.328 18.859,0.716 17.443,0.716 C14.265,0.716 11.929,3.751 12.646,6.901 C8.556,6.691 4.928,4.686 2.499,1.638 C1.210,3.902 1.831,6.864 4.023,8.364 C3.217,8.337 2.456,8.111 1.794,7.734 C1.740,10.067 3.374,12.251 5.742,12.737 C5.050,12.929 4.291,12.974 3.518,12.822 C4.144,14.824 5.962,16.279 8.118,16.320 C6.048,17.981 3.441,18.722 0.829,18.407 C3.007,19.837 5.596,20.671 8.376,20.671 C17.517,20.671 22.681,12.771 22.369,5.687 C23.331,4.976 24.166,4.089 24.826,3.079 Z"
			/>
		</svg>
	);
};

export const AccordionArrowIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="22px" height="12px">
			<path d="M11.629,11.732 L21.008,2.080 C21.313,1.766 21.313,1.251 21.008,0.936 C20.702,0.622 20.202,0.622 19.896,0.936 L11.074,10.016 L2.251,0.936 C1.945,0.622 1.445,0.622 1.139,0.936 C0.834,1.251 0.834,1.766 1.139,2.080 L10.518,11.732 C10.824,12.047 11.323,12.047 11.629,11.732 Z" />
		</svg>
	);
};

export const HamburgerMenuIcon = () => {
	return (
		<svg width="44" height="28" viewBox="0 0 44 28" xmlns="http://www.w3.org/2000/svg">
			<path d="M0 0H44V4H0V0Z" />
			<path d="M0 12H44V16H0V12Z" />
			<path d="M0 24H32V28H0V24Z" />
		</svg>
	);
};
